import { render, staticRenderFns } from "./Sdg04.vue?vue&type=template&id=10b4c406&scoped=true&"
import script from "./Sdg04.vue?vue&type=script&lang=js&"
export * from "./Sdg04.vue?vue&type=script&lang=js&"
import style0 from "./Sdg04.vue?vue&type=style&index=0&id=10b4c406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4c406",
  null
  
)

export default component.exports